<template>
  <div class="Dashboard">
    <Breadcrumbs />
    <dashboard-top>
      <screen-title :title="this.$store.state.user.team.name"></screen-title>
    </dashboard-top>

    <div class="container ml-0">
      <section-title title="New event"></section-title>
    </div>
    <div class="container ml-0">
      <Form ref="form" action="Publish event" />
    </div>
  </div>
</template>

<script>
import Form from "@/components/Forms/EventForm";
export default {
  name: "CreateEvent",
  components: {
    Form
  },
  methods: {
    handleSubmit() {
      this.$refs.form.handleSubmitEvent();
    }
  }
};
</script>
